import { render, staticRenderFns } from "./_workspace-sidebar.vue?vue&type=template&id=4eda588c"
import script from "./_workspace-sidebar.vue?vue&type=script&lang=js"
export * from "./_workspace-sidebar.vue?vue&type=script&lang=js"
import style0 from "./_workspace-sidebar.vue?vue&type=style&index=0&id=4eda588c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports